import { DisponibilzarDare } from './disponibilzarDare/types';

export enum Types {
	POTENCIAL_CLEAR = '@potencial/POTENCIAL_CLEAR',
}

export interface PotencialState {
	disponibilzarDare: DisponibilzarDare;
}
